module.exports = __webpack_public_path__ + "static/black_earth_guard-d4f861b3960ccfce86060a88f48bc7e6.jpeg";